import { fetchClass as fetchClassAPI } from "../api";

export const fetchClassAction = async (classID, setClass) => {
  const classObject = await fetchClassAPI(classID);
  setClass(classObject.data);
};
